import {useCallback, useEffect} from 'react'

import {useAppDispatch, useAppSelector} from '../../../hooks/react-redux'
import {useSetUserProperty} from '../../../hooks/useSetUserProperty'
import {useBooleanUserProperty} from '../../../hooks/useUserProperty'
import {UserProperties} from '../../../utils/userProperties'
import {sidebarSettings} from '../../App/SidebarPanel/SidebarPanel.slices'
import useLocalStorageValue from '../../pages/PipelinesPages/hooks/useLocalStorageValue'

import {
  aiAssistantChatButtonCloseEvent,
  aiAssistantChatButtonOpenEvent,
  maxWindowWidth,
  minWindowWidth,
} from './AiAssistantChatWrapper.const'

function useAiAssistantChatWrapper() {
  const dispatch = useAppDispatch()
  const collapsed = useAppSelector(state => state.sidebarSettings.collapsed)
  const pinned = useBooleanUserProperty(UserProperties.SIDEBAR_PINNED, true)
  const [prevStateCollapsed, setPrevStateCollapsed] = useLocalStorageValue(
    'jb.teamcity.pipelines.settingsSidebar.prevStateCollapsed',
  )
  const setUserProperty = useSetUserProperty()
  const closeAiAssistantChatButtonHandler = useCallback(() => {
    if (!pinned && collapsed && prevStateCollapsed === 'false') {
      setUserProperty(UserProperties.SIDEBAR_PINNED, 'true')
      dispatch(sidebarSettings.actions.setSidebarCollapsed(false))
    }
  }, [collapsed, prevStateCollapsed, dispatch, pinned, setUserProperty])
  const openAiAssistantChatButtonHandler = useCallback(() => {
    const windowWidth = window.innerWidth
    const isMoreThanMinWidth = windowWidth > minWindowWidth && windowWidth < maxWindowWidth

    setPrevStateCollapsed(collapsed.toString())

    if (isMoreThanMinWidth && !collapsed && pinned) {
      setUserProperty(UserProperties.SIDEBAR_PINNED, 'false')
      dispatch(sidebarSettings.actions.setSidebarCollapsed(true))
    }
  }, [collapsed, dispatch, pinned, setPrevStateCollapsed, setUserProperty])

  useEffect(() => {
    window.addEventListener(aiAssistantChatButtonCloseEvent, closeAiAssistantChatButtonHandler)
    window.addEventListener(aiAssistantChatButtonOpenEvent, openAiAssistantChatButtonHandler)

    return () => {
      window.removeEventListener(aiAssistantChatButtonCloseEvent, closeAiAssistantChatButtonHandler)
      window.removeEventListener(aiAssistantChatButtonOpenEvent, openAiAssistantChatButtonHandler)
    }
  }, [closeAiAssistantChatButtonHandler, openAiAssistantChatButtonHandler])
}

export default useAiAssistantChatWrapper
